import { ApiFormElementSelectOptionEdit } from "@/types/forms/form-edit.types.ts";

export enum ApiFormScaleType {
  single_scale = "single_scale",
  double_scale = "double_scale",
}

export interface ApiFormScaleDataAnswer {
  uuid: string;
  emoji: string | null;
  title: string | null;
  description: string | null;
}

export interface ApiFormScaleDataScale {
  answers: ApiFormScaleDataAnswer[];
}

export interface ApiFormScaleData {
  type: ApiFormScaleType;
  title: string;
  scale: ApiFormScaleDataScale;
  scale2: ApiFormScaleDataScale | null;
}

export interface ApiFormScale {
  id: number;
  scale_data: ApiFormScaleData;
}

export type ApiFormViewScaleOptionPayload = ApiFormElementSelectOptionEdit;

export interface ApiFormViewScalePayload {
  title: string;
  type: ApiFormScaleType;
  scale: ApiFormViewScaleOptionPayload[];
  scale2?: ApiFormViewScaleOptionPayload[];
}
